<template>
<html>隐私协议</html>
</template>

<script>
export default {
    name:'Policy'
}
</script>


// WEBPACK FOOTER //
// src/views/Policy.vue